import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_items_below_apply_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'which_of_the_items_below_apply_select_all_that_apply',
  name: 'Please specify which of the items below apply',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WORKERS_WERE_NOT_GIVEN_NOTICE_PRIOR_TO_TERMINATION_IN_LINE_WITH',
      text: 'Workers were not given notice prior to termination in line with applicable legal requirements',
      externalIds: [
        {
          id: 'ep-9',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_DID_NOT_HAVE_AN_OPPORTUNITY_TO_DEFEND_THEMSELVES_BEFORE',
      text: 'Workers did not have an opportunity to defend themselves before they were terminated based on their conduct or performance',
      externalIds: [
        {
          id: 'ep-10',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_TERMINATED_FOR_INVALID_REASONS',
      text: 'Workers were terminated for invalid reasons',
      externalIds: [
        {
          id: 'ter-emp-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_NOT_PAID_CORRECTLY_FOR_OUTSTANDING_WAGES',
      text: 'Workers were not paid correctly for outstanding wages',
      externalIds: [
        {
          id: 'wb-28',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_NOT_PAID_CORRECT_SEVERANCE_PAYMENTS',
      text: 'Workers were not paid correct severance payments',
      externalIds: [
        {
          id: 'ter-emp-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMINATION_PAYMENTS_WERE_NOT_PAID_ON_TIME',
      text: 'Termination payments were not paid on time',
      externalIds: [
        {
          id: 'ter-emp-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_NOT_COMPENSATED_CORRECTLY_FOR_UNUSED_ANNUAL_LEAVE',
      text: 'Workers were not compensated correctly for unused annual leave',
      externalIds: [
        {
          id: 'ter-emp-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_NOT_PAID_OTHER_TERMINATION_BENEFITS_IN_LINE_WITH_L',
      text: 'Workers were not paid other termination benefits in line with legal requirements',
      externalIds: [
        {
          id: 'ter-emp-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_DID_NOT_COMPLY_WITH_ANY_ORDER_S_TO_REINSTATE_OR_CO',
      text: 'The facility did not comply with any order(s) to reinstate or compensate workers who were found to be unjustly terminated',
      externalIds: [
        {
          id: 'ter-emp-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_BEFORE_SUSPEND',
      text: 'Does the facility comply with legal requirements before suspending workers or reducing the size of the workforce due to economic, technological, structural, operational or other similar changes?',
      externalIds: [
        {
          id: 'ter-emp-9',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WORKERS_WERE_NOT_GIVEN_NOTICE_PRIOR_TO_TERMINATION_IN_LINE_WITH',
                'WORKERS_DID_NOT_HAVE_AN_OPPORTUNITY_TO_DEFEND_THEMSELVES_BEFORE',
                'WORKERS_WERE_TERMINATED_FOR_INVALID_REASONS',
                'WORKERS_WERE_NOT_PAID_CORRECTLY_FOR_OUTSTANDING_WAGES',
                'WORKERS_WERE_NOT_PAID_CORRECT_SEVERANCE_PAYMENTS',
                'TERMINATION_PAYMENTS_WERE_NOT_PAID_ON_TIME',
                'WORKERS_WERE_NOT_COMPENSATED_CORRECTLY_FOR_UNUSED_ANNUAL_LEAVE',
                'WORKERS_WERE_NOT_PAID_OTHER_TERMINATION_BENEFITS_IN_LINE_WITH_L',
                'THE_FACILITY_DID_NOT_COMPLY_WITH_ANY_ORDER_S_TO_REINSTATE_OR_CO',
                'DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_BEFORE_SUSPEND',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ter-emp-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17790,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
